/**
 * Roll optimistic star ratings back when their Livewire request itself fails.
 *
 * `/scout/athletes` saves a star click without re-rendering, so the stars update in the
 * browser first (asg::partials.star-rating, `optimisticUuid`). In Livewire 3.8 a `$wire`
 * method promise only settles from a successful response's `returns`: an HTTP 5xx/504 or a
 * network failure runs the commit's `fail` callbacks and leaves the promise pending. Without
 * this, a coach would keep seeing stars that were never saved.
 *
 * The `commit` hook is per component, so only the component whose request failed reports,
 * and only for the uuids it was rating. A success never dispatches.
 */
export const RATING_REQUEST_FAILED_EVENT = 'asg-rating-request-failed';

const OPTIMISTIC_RATING_METHODS = ['rateAthlete', 'markNotEnoughExposure'];

/**
 * @param {{ hook: Function }} livewire
 * @param {(detail: { componentId: string, uuids: string[] }) => void} dispatch
 */
export function registerRatingRollback(livewire, dispatch) {
    livewire.hook('commit', ({ component, commit, fail }) => {
        const uuids = (commit?.calls ?? [])
            .filter((call) => OPTIMISTIC_RATING_METHODS.includes(call.method) && typeof call.params?.[0] === 'string')
            .map((call) => call.params[0]);

        if (uuids.length === 0) {
            return;
        }

        fail(() => dispatch({ componentId: component.id, uuids }));
    });
}
